import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Index from "./views/Index.vue";
import Login from "./views/user/login.vue";
import Pay from "./views/user/pay.vue";
import Register from "./views/user/register.vue";
import Fangan from "./views/home/fangan.vue";
import Baozhang from "./views/home/baozhang.vue";
import Ruzhu from "./views/home/ruzhu.vue";
import serviceRuzhu from "./views/home/service_ruzhu.vue";
import GAbout from "./views/home/about.vue";
import homeHelp from "./views/home/help.vue";
import Download from "./views/home/download.vue";
import isDownload from "./views/home/isDownload.vue";
import PlaceOrder from "./views/user/placeorder.vue";
import UserProtocol from "./views/user/userprotocol.vue";
import Stepone from "./components/user/step_one.vue";
import Steptwo from "./components/user/step_two.vue";
import Orderpayment from "./components/user/order_payment.vue";
import Stepthree from "./components/user/step_three.vue";
import Myorder from "./views/user/my_order.vue";
import Wallet from "./views/user/wallet.vue";
import Commodity from "./views/user/commodity.vue";
import Message from "./views/user/message.vue";
import Notice from "./views/user/notice.vue";
import Right from "./views/user/right.vue";
import Help from "./views/user/help.vue";
import Feedback from "./views/user/feedback.vue";
import Safety from "./views/user/safety.vue";
import Setting from "./views/user/setting.vue";
import About from "./views/user/about.vue";
import Myindex from "./components/user/index.vue";
import Orderinfo from "./components/user/order_info.vue";
import Abnormal from "./components/user/abnormal.vue";
import Allorder from "./components/user/allorder.vue";
import Refund from "./components/user/refund.vue";
import Acceptance from "./components/user/acceptance.vue";
import ApplyorModify from "./components/user/refund_applyormodify.vue";
import Mywallet from "./components/user/my_wallet.vue";
import Withdraw from "./components/user/withdraw.vue";
import Recharge from "./components/user/recharge.vue";
import withdrawMoney from "./components/user/withdraw_money.vue";
import Mycommodity from "./components/user/my_commodity.vue";
import Addcommodity from "./components/user/add_commodity.vue";
import commodityDetail from "./components/user/commodity_detail.vue";
import Messages from "./components/user/messages.vue";
import MessageDetail from "./components/user/MessageDetail.vue";
import noticeDetail from "./components/user/notice_detail.vue";
import notices from "./components/user/notice.vue";
import Rights from "./components/user/right.vue";
import arbitrationDetail from "./components/user/arbitration_detail.vue";
import Feedbacks from "./components/user/feedback/feedback.vue";
import successFeedback from "./components/user/feedback/success_feedback.vue";
import Safetys from "./components/user/safety.vue";
import safetyPhone from "./components/user/safety_phone.vue";
import safetyPassword from "./components/user/safety_password.vue";
import homeAbout from "./components/home/about.vue";
import Contact from "./components/home/contact.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  // base: process.env.publicPath,
  base: "",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: { title: "聚师傅-一站式家具安装服务平台" }
    },
    {
      path: "/pay",
      name: "pay",
      component: Pay,
      meta: { title: "支付-一站式家具安装服务平台" }
    },
    {
      path: "/user",
      name: "user",
      component: Index,
      children: [
        {
          path: "index",
          component: () => import("@/components/user/index"),
          meta: { title: "聚师傅-一站式家具安装服务平台" }
        },
        {
          path: "order",
          component: Myorder,
          children: [
            {
              path: "",
              component: Allorder,
              name: "allOrder",
              meta: { title: "我的订单-一站式家具安装服务平台" }
            },
            {
              path: "orderinfo",
              component: Orderinfo,
              meta: { title: "订单详情-一站式家具安装服务平台" }
            },
            {
              path: "abnormal",
              component: Abnormal,
              meta: { title: "异常处理-一站式家具安装服务平台" }
            },
            {
              path: "acceptance",
              component: Acceptance,
              meta: { title: "验收订单-一站式家具安装服务平台" }
            },
            {
              path: "refund",
              component: Refund,
              name:'orderRefund',
              meta: { title: "退款订单-一站式家具安装服务平台" }
            },
            {
              path: "refund/modify",
              component: ApplyorModify,
              meta: { title: "退款订单修改-一站式家具安装服务平台" }
            }
          ]
        },
        {
          path: "wallet",
          component: Wallet,
          children: [
            {
              path: "",
              component: Mywallet,
              meta: { title: "我的钱包-一站式家具安装服务平台" }
            },
            {
              path: "withdraw",
              component: Withdraw,
              meta: { title: "提现明细-一站式家具安装服务平台" }
            },
            {
              path: "recharge",
              component: Recharge,
              meta: { title: "余额充值-一站式家具安装服务平台" }
            },
            {
              path: "money",
              component: withdrawMoney,
              meta: { title: "申请提现-一站式家具安装服务平台" }
            }
          ]
        },
        {
          path: "followup",
          component: ()=>import("@/views/user/followup"),
          children: [
            {
              path: "record",
              name:'followupRecord',
              component: ()=>import("@/components/user/followup/record"),
              meta: { title: "异常跟进-一站式家具安装服务平台" }
            },
          ]
        },
        {
          path: "profitLoss",
          component: ()=>import("@/views/user/profitLoss"),
          children: [
            {
              path: "order",
              component: ()=>import("@/components/user/profitLoss"),
              meta: { title: "订单盈亏-一站式家具安装服务平台" }
            },
          ]
        },
        {
          path: "batch",
          component: ()=>import("@/views/user/batchOrder"),
          children: [
            {
              path: "order",
              component: ()=>import("@/components/user/batchOrder"),
              meta: { title: "批量下单-一站式家具安装服务平台" }
            },
          ]
        },
        {
          path: "bill",
          component: () => import("@/views/user/bill"),
          meta: { title: "我的账单-一站式家具安装服务平台" }
        },
        {
          path: "commodity",
          component: Commodity,
          children: [
            {
              path: "",
              component: Mycommodity,
              meta: { title: "我的商品-一站式家具安装服务平台" }
            },
            {
              path: "adding",
              component: Addcommodity,
              meta: { title: "添加商品-一站式家具安装服务平台" }
            },
            {
              path: "detail",
              component: commodityDetail,
              meta: { title: "商品详情-一站式家具安装服务平台" }
            }
          ]
        },
        {
          path: "message",
          component: Message,
          children: [
            {
              path: "",
              name:'userMessage',
              component: Messages,
              meta: { title: "消息通知-一站式家具安装服务平台" }
            },
            {
              path: "detail",
              name: "msgDetail",
              component: MessageDetail,
              meta: { title: "消息详情-一站式家具安装服务平台" }
            }
          ]
        },
        {
          path: "notice",
          component: Notice,
          children: [
            {
              path: "",
              component: notices,
              meta: { title: "平台公告-一站式家具安装服务平台" }
            },
            {
              path: "detail",
              name: "noticeDetail",
              component: noticeDetail,
              meta: { title: "公告详情-一站式家具安装服务平台" }
            }
          ]
        },
        {
          path: "right",
          component: Right,
          children: [
            {
              path: "",
              component: Rights,
              meta: { title: "维权中心-一站式家具安装服务平台" }
            },
            {
              path: "detail",
              component: arbitrationDetail,
              meta: { title: "仲裁详情-一站式家具安装服务平台" }
            }
          ]
        },
        {
          path: "help",
          component: Help,
          meta: { title: "帮助中心-一站式家具安装服务平台" }
        },
        {
          path: "feedback",
          component: Feedback,
          children: [
            {
              path: "",
              component: () => import("@/components/user/feedback/list"),
              meta: { title: "意见反馈-一站式家具安装服务平台" }
            },
            {
              path: "success",
              component: successFeedback,
              meta: { title: "反馈成功-一站式家具安装服务平台" }
            },
            {
              path: "submit",
              component: Feedbacks,
              meta: { title: "提交反馈-一站式家具安装服务平台" }
            },
            {
              path: "detail",
              component: () => import("@/components/user/feedback/detail"),
              meta: { title: "意见反馈-一站式家具安装服务平台" }
            }
          ]
        },
        {
          path: "safety",
          component: Safety,
          children: [
            {
              path: "",
              component: Safetys,
              meta: { title: "安全设置-一站式家具安装服务平台" }
            },
            {
              path: "phone",
              component: safetyPhone,
              meta: { title: "修改手机-一站式家具安装服务平台" }
            },
            {
              path: "password",
              component: safetyPassword,
              meta: { title: "修改密码-一站式家具安装服务平台" }
            }
          ]
        },
        {
          path: "setting",
          component: Setting,
          meta: { title: "个人设置-一站式家具安装服务平台" }
        },
        {
          path: "about",
          component: About,
          meta: { title: "关于我们-一站式家具安装服务平台" }
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { title: "登录-一站式家具安装服务平台" }
    },
    {
      path: "/register",
      name: "register",
      component: Register,
      meta: { title: "注册-一站式家具安装服务平台" }
    },
    {
      path: "/fangan",
      name: "fangan",
      component: Fangan,
      meta: { title: "解决方案-一站式家具安装服务平台" }
    },
    {
      path: "/baozhang",
      name: "baozhang",
      component: Baozhang,
      meta: { title: "服务保障-一站式家具安装服务平台" }
    },
    {
      path: "/ruzhu",
      name: "ruzhu",
      component: Ruzhu,
      meta: { title: "师傅入驻-一站式家具安装服务平台" }
    },
    {
      path: "/service_ruzhu",
      name: "service_ruzhu",
      component: serviceRuzhu,
      meta: { title: "服务商入驻-一站式家具安装服务平台" }
    },
    {
      path: "/about",
      name: "about",
      component: GAbout,
      children: [
        {
          path: "",
          component: homeAbout,
          meta: { title: "关于我们-一站式家具安装服务平台" }
        },
        {
          path: "contact",
          component: Contact,
          meta: { title: "联系我们-一站式家具安装服务平台" }
        }
      ]
    },
    {
      path: "/help",
      name: "help",
      component: homeHelp,
      meta: { title: "帮助中心-一站式家具安装服务平台" }
    },
    {
      path: "/download",
      name: "download",
      component: Download,
      meta: { title: "APP下载-一站式家具安装服务平台" }
    },
    {
      path: "/isDownload",
      name: "isDownload",
      component: isDownload,
      meta: { title: "下载" }
    },
    {
      path: "/placeorder",
      name: "placeorder",
      component: PlaceOrder,
      children: [
        {
          path: "stepone",
          name: "stepOne",
          component: Stepone,
          meta: { title: "步骤一-一站式家具安装服务平台" }
        },
        {
          path: "Steptwo",
          component: Steptwo,
          meta: { title: "步骤二-一站式家具安装服务平台" }
        },
        {
          path: "Orderpayment",
          component: Orderpayment,
          meta: { title: "订单支付-一站式家具安装服务平台" }
        },
        {
          path: "Stepthree",
          component: Stepthree,
          meta: { title: "支付完成-一站式家具安装服务平台" }
        },
        {
          path: "speedOrder",
          name: "speedOrder",
          component: () => import("@/components/user/SpeedOrder"),
          meta: { title: "即时下单-一站式家具安装服务平台" },
        },
      ]
    },
    {
      path: "/userprotocol",
      name: "userprotocol",
      component: UserProtocol,
      meta: { title: "用户协议-一站式家具安装服务平台" }
    },
    {
      path:'/map',
      name: "map",
      component:  () => import("@/views/map/index"),
      meta: { title: "一站式家具安装服务平台" }
    },
    {
      path: "/404",
      component: () => import("@/views/exception/404")
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
});
